import React, { ReactType } from 'react';

import { Container, TextWrapper } from './styled';
import { IAddNewCard } from './types';

const AddNewCard = ({ text, icons, onClick }: IAddNewCard) => {
  const handleOnClick = (e: React.MouseEvent) => {
    onClick?.(e);
  };

  return (
    <Container onClick={handleOnClick} data-testid="add-new-prepaid-card">
      <TextWrapper>
        <p>{text}</p>
        {icons.map((Icon: ReactType) => (
          <Icon key={Icon} />
        ))}
      </TextWrapper>
    </Container>
  );
};

export default AddNewCard;
